import React from "react";
import { Box, Typography } from "@tiny/components";
import { usePredefinedSegmentsContext } from "./PredefinedSegments.context";

interface SectionHeaderProps {
  id: string;
  title: string | JSX.Element;
  subtitle: string | JSX.Element;
}

export function SectionHeader({ id, title, subtitle }: SectionHeaderProps) {
  const { isDisabled = false } = usePredefinedSegmentsContext();
  return (
    <Box id={id} mb={3} flexBasis={isDisabled ? "70%" : "100%"}>
      <Typography
        variant="h4"
        component="h4"
        fontWeight="semiBold"
        color="grey"
        tone={900}
        noWrap
        mt={0}
        mb={1}
      >
        {title}
      </Typography>
      <Typography
        variant="body3"
        component="span"
        color="grey"
        tone={700}
        m={0}
        pr={2}
      >
        {subtitle}
        {isDisabled && (
          <>
            <Box component="span" color="primary.main">
              Upgrade to Pro
            </Box>
            &nbsp;plan to use.
          </>
        )}
      </Typography>
    </Box>
  );
}
